import { atom, useAtom } from 'jotai';
import { EDTEvent } from '@teetsh/app/src/types/edt';

type EDTHistory = { [key: string]: Array<EDTEvent[]> };

const futureEDTAtom = atom<EDTHistory>({});
const pastEDTAtom = atom<EDTHistory>({});

const MAX_HISTORY_SIZE = 20;

export function useEDTHistory(edtId: string) {
  const [past, setPast] = useAtom(pastEDTAtom);
  const [future, setFuture] = useAtom(futureEDTAtom);

  return {
    past: past[edtId] || [],
    resetFuture: () => {
      setFuture({ ...future, [edtId]: [] });
    },
    addToPast: (v: Array<EDTEvent>) => {
      const edtPast = past[edtId] || [];
      setPast({
        ...past,
        [edtId]: [...edtPast.slice(MAX_HISTORY_SIZE * -1), v],
      });
    },
    isFutureEmpty: (future[edtId] || []).length === 0,
    isPastEmpty: (past[edtId] || []).length === 0,
    setPast: (v: Array<EDTEvent[]>) => setPast({ ...past, [edtId]: v }),
    setFuture: (v: Array<EDTEvent[]>) => setFuture({ ...future, [edtId]: v }),
    future: future[edtId] || [],
  };
}

export const addToEDTPast = atom(
  null,
  (get, set, v: { edtId: string; seances: EDTEvent[] }) => {
    const pastEDT = get(pastEDTAtom)[v.edtId] || [];
    set(pastEDTAtom, {
      ...get(pastEDTAtom),
      [v.edtId]: [...pastEDT.slice(MAX_HISTORY_SIZE * -1), v.seances],
    });
    return set(futureEDTAtom, {
      ...get(futureEDTAtom),
      [v.edtId]: [],
    });
  },
);
